import React, { useEffect, useState } from 'react'
import styles from "./CustomDesktopPagination.module.scss";
import Srcset from '@/components/common/Srcset';
import useMediaQuery from "@/helpers/hooks/useMediaQuery";

const CustomMDesktopPagination = ({ paginationState, dispatch }) => {
  const { currentPage, totalPages } = paginationState

  const [pageMapping, setPageMapping] = useState([])
  let displayProducts
  // to handle document not found error
  if(typeof document !== "undefined") {
    displayProducts = document?.querySelector('.injected-content');
  }
  const isMobile = useMediaQuery("(max-width: 600px)");
  // guide the users to the top when changing the page
  const scrollToTop = () => {
    // added a slight delay to ensure the scrolling occurs after the page has rendered
    setTimeout(() => {
      // get the Products container div to scroll upto i.e. className desk_hide for mobile & mob_hide for desktop
      let sectionToBeScrolledTo = "";
      if(isMobile){
        sectionToBeScrolledTo = document?.querySelector('.desk_hide')
      }else{
        sectionToBeScrolledTo = document?.querySelector('.mob_hide')
      }
      sectionToBeScrolledTo.scrollIntoView({ behavior: 'instant' })
    }, 100)

  }

  // pagination button click handlers
  const plpLoaderHide = () => {
    setTimeout(() => {
      if (document.querySelector('.hit-img img.load-listener-added')) {
        return;
      }
      document.querySelector('.hit-img img').addEventListener('load', (e) => {
        document.querySelector('.for-plp-loading').classList.remove('loading');
        if(displayProducts) {
          displayProducts.style.filter ="none"
        }
      })
      document.querySelector('.hit-img img').classList.add('load-listener-added');
    }, 200);
  }
  const plpShowLoader = () => {
    let loadingDiv = document.querySelector('.for-plp-loading');
    if (loadingDiv) {
      loadingDiv.classList.add('loading');
      if(displayProducts) {
        displayProducts.style.filter="blur(5px)"
      }
    }
  }
  const commonFunctionPagination = () => {
    scrollToTop();
    plpShowLoader();
    plpLoaderHide();
  }
  const handleGoToFirstPage = () => {
    commonFunctionPagination();
    dispatch({ type: "GO_TO_FIRST_PAGE" });
  }
  const handleGoToLastPage = () => {
    commonFunctionPagination();
    dispatch({ type: "FETCH_DATA_FOR_SELECTED_PAGE", payload: { page: totalPages, shouldChangeURL: true } });
  }
  const handleGoToNextPage = () => {
    commonFunctionPagination();
    dispatch({ type: "FETCH_NEXT_PAGE_DESKTOP" });
  }
  const handleGoToPreviousPage = () => {
    commonFunctionPagination();
    dispatch({ type: "FETCH_PREVIOUS_PAGE_DESKTOP" });
  }
  const handleGoToSelectedPage = (page) => {
    if(currentPage != page) {
      commonFunctionPagination();
      dispatch({ type: "FETCH_DATA_FOR_SELECTED_PAGE", payload: { page: page, shouldChangeURL: true } });
    }
  }

  // render the page buttons
  const renderButtonsRow = () => {
    return (
      <>
        {pageMapping.map((page, index) => (
          <button
            key={index}
            className={`${page === currentPage ? 'selected normal' : 'normal'}`}
            onClick={() => handleGoToSelectedPage(page)}
          >
            {page}
          </button>
        ))}
      </>
    )
  }

  // handles the pageMapping array based on the current page and total pages value
  const getPaginationNumberMapper = () => {
    let pages = []
    switch (true) {
      case totalPages <= 5:
        for (let i = 0; i < totalPages; i++) {
          pages.push(i + 1)
        }
        setPageMapping(pages)
        break;
      case totalPages > 5 && currentPage + 2 <= totalPages - 2 && currentPage - 2 >= 1:
        for (let i = currentPage - 2; i <= currentPage + 2; i++) {
          pages.push(i)
        }
        setPageMapping(pages)
        break;
      case totalPages > 5 && currentPage + 4 > totalPages:
        for (let i = totalPages - 4; i <= totalPages; i++) {
          pages.push(i)
        }
        setPageMapping(pages)
        break;
      default:
        for (let i = 1; i <= 5; i++) {
          pages.push(i)
        }
        setPageMapping(pages)
    }
  }

  // handle page number buttons on change
  useEffect(() => {
    getPaginationNumberMapper();
  }, [totalPages, currentPage])

  return (
    <>
      <div className={`${styles.PLP_desktop_paginator} auto-paginator-desktop`}>
        {currentPage === 1?<></>:<><button
          onClick={handleGoToFirstPage}
          disabled={currentPage === 1}
          className={`${styles.btn_ht}`}
        >
          <Srcset
            height={13}
            width={13}
            className={""}
            requirePath={true}
            svgFile={true}
            src={"images/Icons/Chevron/Double-chevron.svg"}
            alt="Prev arrow"
            title="First"
          />
        </button>
        <button
          onClick={handleGoToPreviousPage}
          disabled={currentPage === 1}
          className={`${styles.btn_ht}`}
        >
          <Srcset
            height={13}
            width={13}
            className={styles.prev}
            requirePath={true}
            svgFile={true}
            src={"images/Icons/Chevron/large.svg"}
            alt="Prev arrow"
            title="Prev"
          />        
        </button></>}
        {renderButtonsRow()}
        { currentPage >= totalPages ? 
        <></>
        :<> 
          <button
          disabled={currentPage >= totalPages}
          onClick={handleGoToNextPage}
          className={`${styles.PLP_pagination_util_buttons} ${styles.btn_ht}`}
        >
          <Srcset
            height={13}
            width={13}
            className={styles.next}
            requirePath={true}
            svgFile={true}
            src={"images/Icons/Chevron/large.svg"}
            alt="Next arrow"
            title="Next"
          />
          </button>
        <button
          disabled={currentPage >= totalPages}
          onClick={handleGoToLastPage}
          className={`${styles.btn_ht} ${styles.PLP_pagination_util_buttons}`}
        >
           <Srcset
            height={13}
            width={13}
            className={styles.next_dbl}
            requirePath={true}
            svgFile={true}
            src={"images/Icons/Chevron/Double-chevron.svg"}
            alt="Next arrow"
            title="Last"
          />
        </button> 
        </>
        }
      </div>
    </>

  )
}

export default CustomMDesktopPagination